/**
 * @copyright 丽汽智贸平台 V1.0
 * @year 2026
 * @file index.js
 * @description API 接口封装
 */
import http from "../utils/http";
import crypto from "../utils/crypto";

/**
 * 手机号验证码登录
 * 手机号使用 DES 加密后传输
 * @param {Object} params - { mobile: 手机号, code: 验证码, rememberMe: 是否记住我 }
 */
export function loginByPhoneAndCode(params) {
  const encryptedData = {
    mobile: crypto.encryptPhone(params.mobile),
    code: params.code,
    rememberMe: params.rememberMe || false,
    browser: params.browser || "",
    os: params.os || "",
    deviceInfo: params.deviceInfo || "",
  };
  return http.post("/api/user/LoginByPhoneAndCode", encryptedData);
}

/**
 * 发送短信验证码
 * 手机号使用 DES 加密后传输
 * @param {Object} params - { phoneNo: 手机号 }
 */
export function getPhoneCode(params) {
  const encryptedPhone = crypto.encryptPhone(params.phoneNo);
  return http.post("/api/user/GetPoneCode", { phone: encryptedPhone });
}

/**
 * 获取用户菜单权限
 */
export function getUserMenus() {
  return http.get("/api/User/GetUserMenus");
}

/**
 * 获取用户所有权限列表
 */
export function getUserPermissions() {
  return http.get("/api/User/GetUserPermissions");
}

/**
 * 获取用户单位信息
 */
export function getUserUnitInfo() {
  return http.get("/api/User/GetUserUnitInfo");
}

/**
 * 获取登录历史记录
 * @param {number} top - 获取条数
 */
export function getLoginHistory(top = 10) {
  return http.get(`/api/User/GetLoginHistory?top=${top}`);
}

/**
 * 获取待盘点任务
 */
export function getPendingTasks() {
  return http.get("/api/Inventory/GetPendingTasks");
}

/**
 * 上传视频或照片并提交盘点
 * @param {FormData} formData - 包含 recordId, video, remark
 */
export function uploadAndCheck(formData) {
  return http.post("/api/Inventory/UploadAndCheck", formData, {
    //headers: { "Content-Type": "multipart/form-data" },
    timeout: 300000,
  });
}

/**
 * 获取已盘点记录
 * @param {number} page - 页码
 * @param {number} pageSize - 每页条数
 */
export function getCheckedRecords(page = 1, pageSize = 20) {
  return http.get(`/api/Inventory/GetCheckedRecords?page=${page}&pageSize=${pageSize}`);
}

/**
 * 获取业务看板数据
 * @param {string} beginDate - 开始日期
 * @param {string} endDate - 结束日期
 */
export function getDashboardData(beginDate, endDate) {
  return http.get(`/api/Dashboard/GetDashboardData?beginDate=${beginDate}&endDate=${endDate}`);
}

/**
 * 获取盘点媒体文件列表
 * @param {number} recordId - 盘点记录ID
 * @param {string} fileType - 文件类型: photo/video，不传则返回全部
 */
export function getMediaList(recordId, fileType = null) {
  let url = `/api/Inventory/GetMediaList/${recordId}`;
  if (fileType) url += `?fileType=${fileType}`;
  return http.get(url);
}

/**
 * 删除单个媒体文件
 * @param {number} formData - 媒体文件ID
 */
export function deleteCheckRecord(formData) {
  return http.post("/api/Inventory/DeleteCheckRecord", formData);
}

export default {};
